<template>
  <div id="question-thread" class="report">
    <mu-row v-if="!isLoading" class="content" gutter>
      <mu-col width="100" desktop="70" tablet="70">
        <mu-card class="bottom">
          <mu-card-text class="userCard" v-if="!isLoading">
            <mu-avatar
              class="userImage"
              :size="105"
              v-if="!question.user.avatar"
              color="#0179d5"
              backgroundColor="#E9E9E8"
              src="static/avatar.png">
            </mu-avatar>
            <mu-avatar class="userImage" :size="105" v-if="question.user.avatar" :src="question.user.avatar"></mu-avatar>
            <div class="userBlock">
              <div class="badges">
                <user-badge v-if="question.user.is_admin" type="support" mode="image"></user-badge>
                <user-badge v-if="question.user.is_champion" type="champion" mode="image"></user-badge>
                <user-badge v-if="question.user.is_complete" type="finished-program" mode="image"></user-badge>
              </div>
              <div>
                <router-link :to="{path: '/profile/' + question.user.profile.url}">
                  {{encodeText(question.user.display_name)}} <country-badge :alpha2="question.user.country.alpha2" :tooltip="question.user.country.country_name"></country-badge>
                </router-link>
              </div>
              <div class="blueLine">{{question.user.diabetes_type}}</div>
              <div>Posts: {{question.posts}}</div>
            </div>
          </mu-card-text>
          <mu-card-text v-if="question.content">
            <vue-markdown :source="encodeText(question.content)"
                         style="white-space: pre-wrap;">

            </vue-markdown>
          </mu-card-text>
          <mu-card-actions>
            <mu-flat-button icon="history" label="See all replies" @click.native="goToThread()"></mu-flat-button>
          </mu-card-actions>
        </mu-card>
        <h2>Reported answer</h2>
        <mu-card>
          <mu-card-text class="userCard" v-if="!isLoading">
            <mu-avatar
              class="userImage"
              :size="105"
              v-if="!answer.user.avatar"
              color="#0179d5"
              backgroundColor="#E9E9E8"
              src="static/avatar.png">
            </mu-avatar>
            <mu-avatar class="userImage" :size="105" v-if="answer.user.avatar" :src="answer.user.avatar"></mu-avatar>
            <div class="userBlock">
              <div class="badges">
                <user-badge v-if="answer.user.is_admin" type="support" mode="image"></user-badge>
                <user-badge v-if="answer.user.is_champion" type="champion" mode="image"></user-badge>
                <user-badge v-if="answer.user.is_complete" type="finished-program" mode="image"></user-badge>
              </div>
              <div>
                <router-link :to="{path: '/profile/' + answer.user.profile.url}">
                  {{encodeText(answer.user.display_name)}} <country-badge :alpha2="answer.user.country.alpha2" :tooltip="answer.user.country.country_name"></country-badge>
                </router-link>
              </div>
              <div class="blueLine">{{answer.user.diabetes_type}}</div>
              <div>Posts: {{answer.posts}}</div>
            </div>
          </mu-card-text>
          <mu-card-text
                  v-if="answer.answer">
            <vue-markdown :source="encodeText(answer.answer)"
                         style="white-space: pre-wrap;">

            </vue-markdown>
          </mu-card-text>
        </mu-card>
        <report :typeId="parseInt($route.params.id)" type="THREAD_ANSWER"></report>
      </mu-col>
      <mu-col width="100" desktop="30" tablet="30">
        <form @submit.prevent="submitForm" novalidate>
          <mu-card>
            <mu-card-header titleClass="blueTitle largeTitle" title="Handle report"></mu-card-header>
            <mu-card-text style="padding-top: 0">
              What do you want to do this with answer?
            </mu-card-text>
            <mu-card-text>
              <div>
                <mu-radio v-model="model.status" nativeValue="KEEP" label="Keep it"></mu-radio>
              </div>
              <div>
                <mu-radio v-model="model.status" nativeValue="REMOVE" label="Remove it"></mu-radio>
              </div>
            </mu-card-text>
            <button type="submit" style="display: none;"></button>
            <mu-card-actions align="right">
              <mu-raised-button type="button" @click.native="submitForm" label="Ammend" secondary></mu-raised-button>
            </mu-card-actions>
          </mu-card>
        </form>

      </mu-col>
    </mu-row>
  </div>
</template>
<script>

  import HTMLStringParser from '../../helpers/HTMLStringParser'
  import ReportingApi from '../../api/Reporting'
  import DiscussionApi from '../../api/Discussion'
  import TitleManager from '../../helpers/TitleManager'
  import UserBadge from "../../components/UserBadge/UserBadge.vue";
  import CountryBadge from "../../components/CountryBadge/CountryBadge.vue"
  import Report from "../../components/Reporting/Report.vue";

  export default {
    components: {
      Report,
      UserBadge,
      CountryBadge,
    },
    data() {
      return {
        isLoading: true,
        question: {},
        answer: {},
        report: {},
        isAmmending: false,
        model: {
          status: "REMOVE"
        }
      }
    },
    mounted() {
      let self = this;
      let answerId = self.$route.params.id;
      self.isLoading = true;
      TitleManager.setTitle(self.$t('message.loadingText'));
      ReportingApi.getAnswerReport(answerId)
        .then(function (response) {
          self.question = response.data.question;
          self.answer = response.data.answer;
          self.report = response.data.report;
          self.isLoading = false;
          TitleManager.setTitle(self.answer.answer)
        })
        .catch(function () {
          self.$router.push({
            name: 'QuestionsIndex'
          })
        })
    },
    methods: {
      goToThread() {
        let self = this;
        self.$router.push({
          name: 'QuestionThread',
          params: {
            id: self.answer.question_id
          }
        })
      },
      submitForm() {
        let self = this;
        if (self.$validator.validateAll()) {
          self.isAmmending = true;
          if (self.model.status === 'REMOVE') {
            self.$alert({
              title: "Are you sure?",
              text: "You are removing an answer and all of its reports",
              type: "warning",
              showCancelButton: true,
              showLoaderOnConfirm: false,
              confirmButtonColor: "white",
              cancelButtonColor: "white",
              preConfirm: function () {
                return DiscussionApi.deleteAnswer(self.answer.answer_id)
              }
            })
              .then(function (response) {
                self.$router.push({
                  name: 'QuestionThread',
                  params: {
                    id: self.answer.question_id
                  }
                });
                self.$toastr.success("Answer was removed from " + self.question.user.display_name + 's question')
              }.bind(self))
              .catch(self.$alert.noop);

          }

          if (self.model.status === 'KEEP') {
            self.$alert({
              title: "Are you sure?",
              text: "You want to keep the answer and reject all reports",
              type: "warning",
              showCancelButton: true,
              showLoaderOnConfirm: false,
              confirmButtonColor: "white",
              cancelButtonColor: "white",
              preConfirm: function () {
                return ReportingApi.removeReports("THREAD_ANSWER", self.answer.answer_id)
              }
            })
              .then(function (response) {
                self.$router.push({
                  name: 'QuestionThread',
                  params: {
                    id: self.answer.question_id
                  }
                });
                self.$toastr.success("All reports for this answer were removed")
              }.bind(self))
              .catch(self.$alert.noop);
          }
        }
      },
      encodeText(string) {
        return HTMLStringParser.encode(string);
      }
    }
  }
</script>
<style lang="less">
  @import '../Questions/Questions.less';
</style>



// WEBPACK FOOTER //
// AnswerReport.vue?00933847